export default __webpack_public_path__ + "static/media/storyVideoItem.992eb7b9.svg";